import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class FacturacionApiService {
  apiURL: string = config.API_DATA_URL + '/facturacion';
  data: any[] = [];

  constructor(public http: HttpClient) { }

  public GetFacturcion(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturacion/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetFacturacionOrdenServicio(idOrdenServicio: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetFacturacionOrdenServicio/' + idOrdenServicio, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public RegistrarFacturacion(facturacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(facturacion);
    return this.http.post(this.apiURL + '/RegistrarFacturacion', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public OrdenFacturada(facturada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(facturada);
    return this.http.post(this.apiURL + '/OrdenFacturada', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarArchivo(datos: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(datos);
    return this.http.post(this.apiURL + '/ActualizarArchivo', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public GetCobranzaSucursal(idSucursal: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetCobranzaSucursal/' + idSucursal, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public GetDatosFacturacion(idFacturacion: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(this.apiURL + '/GetDatosFacturacion/' + idFacturacion, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError)
  }

  public FacturacionCobrada(facturacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(facturacion);
    return this.http.post(this.apiURL + '/FacturacionCobrada', param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/facturacion-api.service.ts